import ValidationHelperV2 from "utils/ValidationHelperV2";

export const VALIDATION_DELAY = 1000;

export function validateInitial(component, validations, useImmediateValidation = false) {
    component.yupRules = {};
    component.immediateValidation = useImmediateValidation;
    let errors = {};
    validations.forEach(singleValidation => {
        component.yupRules[singleValidation.field] = singleValidation.yupRule;
        if (singleValidation.yupRule) {
            if (singleValidation.value && singleValidation.value.length > 0) {
                component.immediateValidation = true;
                let errorResult = ValidationHelperV2.validateField(singleValidation.yupRule, singleValidation.value);
                if (errorResult.length > 0) {
                    errors[singleValidation.field] = errorResult;
                }
            } else {
                errors[singleValidation.field] = "";
            }
        }
    });
    return errors;
}

export function validateOnChange(component, key, value) {
    if (component.scheduledValidation !== null) {
        clearTimeout(component.scheduledValidation);
    }
    let error = ValidationHelperV2.validateField(component.yupRules[key], value);
    if (component.immediateValidation === true || error.length === 0) {
        setError(component, key, error);
    } else {
        component.scheduledValidation = setTimeout(() => {
            setError(component, key, error);
        }, VALIDATION_DELAY);
    }
    return error;
}

export function setError(component, key, error) {
    component.immediateValidation = true;
    let errors = component.state ? {...component.state.errors} : {}
    if (error.length > 0) {
        errors[key] = error;
    } else {
        delete errors[key];
    }
    component.setState({errors: errors});
}

const ValidationMethod = {
    validateInitial,
    validateOnChange
};
export default ValidationMethod;